module.exports = __webpack_public_path__ + "img/home.15c0499d.svg";